<template>
    <div>
        <b-modal v-model="mostrarModal">
            <div slot="modal-title">Informações TCU - SGTEC</div>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data de pagamento (DE)</label>
                        <date-picker
                            v-model="dataPagamentoDe"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label class="required">Data de pagamento (ATÉ)</label>
                        <date-picker
                            v-model="dataPagamentoAte"
                            :config="$datePickerOptions2"
                            v-mask="'##/##/####'"
                            :disabled="dataPagamentoDe == null"
                        ></date-picker>
                    </b-form-group>
                </b-col>
                <div v-if="$v.$invalid" class="d-block invalid-feedback ml-3 mb-3" style="font-size: 100%;">
                    Verifique as datas de inicio e final de pagamento.
                </div>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group>
                        <label>Módulo</label>
                        <b-form-select
                            v-model="modulo"
                            :options="tiposModulo"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fechar()"
                    class="mr-2"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="$v.$invalid"
                    @click.stop="filtrar()"
                    >Emitir Relatório</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { computed } from 'vue'
import RelatoriosServicos from '../relatorios/RelatoriosServicos'
import download from '../../../shared/download'
import { tiposModulo } from './tiposModulo'
import { required } from 'vuelidate/lib/validators'
import { validacaoDataPagamentoAte } from '../../../shared/vue-validacoes'

export default {
    data() {
        return {
            mostrarModal: false,
            dataPagamentoDe: null,
            dataPagamentoAte: null,
            modulo: 3,
            tiposModulo: tiposModulo
        }
    },

    methods: {
        abrir() {
            this.mostrarModal = true
        },

        fechar() {
            this.mostrarModal = false
            this.dataPagamentoAte = null
            this.dataPagamentoDe = null
        },
        filtrar() {
            this.$store.dispatch('addRequest')
            let filtroProjetoDto = {}
            filtroProjetoDto.dataPagamentoDe = this.$moment(this.dataPagamentoDe,'DD/MM/YYYY').format('YYYY-MM-DD')
            filtroProjetoDto.dataPagamentoAte = this.$moment(this.dataPagamentoAte,'DD/MM/YYYY').format('YYYY-MM-DD')
            filtroProjetoDto.modulo = this.modulo
            RelatoriosServicos.obterFiltroProjetos(filtroProjetoDto).then(response => {
                this.$store.dispatch('removeRequest')
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Falha ao obter relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$toast.success(
                            'Relatório gerado com sucesso',
                            'SUCESSO',
                            this.$toastConfig.success
                        )
                        download(response, `Relatorio_TCU_PROJETOS.xlsx`)
                    }
                    this.fechar()
                } else {
                    this.$toast.error(
                        'Falha ao obter relatório',
                        'ERROR',
                        this.$toastConfig.error
                    )
                }
            })
        }
    },
    computed: {
       
    },
    validations: {
        dataPagamentoAte: {
            validacaoDataPagamentoAte,
            required
        },
        dataPagamentoDe: {
            required
        }
    }
}
</script>
